import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest, MICROSOFT_DOMAIN } from '../../authConfig';
import { authenticationService } from '../../services';

// Decodes a JWT payload (the id_token) without verifying it - verification
// happens server-side. Used only to read the email/exp claims client-side.
function decodeJwt(token) {
    try {
        const payload = token.split('.')[1];
        const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
        return JSON.parse(decodeURIComponent(escape(json)));
    } catch (e) {
        return null;
    }
}

function MicrosoftSSO() {
    const { instance } = useMsal();

    const handleLogin = async () => {
        try {
            const response = await instance.loginPopup(loginRequest);
            const claims = decodeJwt(response.idToken) || response.idTokenClaims || {};
            // Match the backend's extraction order: email -> preferred_username -> upn.
            const email = (claims.email || claims.preferred_username || claims.upn || '').toLowerCase();

            if (!email.endsWith('@' + MICROSOFT_DOMAIN)) {
                console.error('Microsoft login rejected - invalid domain:', email);
                authenticationService.logout();
                return;
            }

            // Hand off in the exact shape the Google flow feeds authenticationService:
            // login(profile{email, imageUrl}, tokenObj{id_token, expires_at}).
            authenticationService.login(
                { email, imageUrl: '' },
                { id_token: response.idToken, expires_at: (claims.exp || 0) * 1000 }
            );
        } catch (error) {
            console.error(error);
            // A user closing the popup is not a failure - only log out on real errors.
            if (!error || error.errorCode !== 'user_cancelled') {
                authenticationService.logout();
            }
        }
    };

    const applyHover = (e) => {
        e.currentTarget.style.backgroundColor = '#f8f9fa';
        e.currentTarget.style.boxShadow =
            '0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15)';
    };
    const clearHover = (e) => {
        e.currentTarget.style.backgroundColor = '#ffffff';
        e.currentTarget.style.boxShadow = 'none';
    };

    return (
        <button
            type="button"
            onClick={handleLogin}
            onMouseEnter={applyHover}
            onMouseLeave={clearHover}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                maxWidth: '240px',
                padding: '10px 24px',
                cursor: 'pointer',
                backgroundColor: '#ffffff',
                color: '#3c4043',
                border: '1px solid #dadce0',
                borderRadius: '4px',
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: '"Google Sans", Roboto, Arial, sans-serif',
                transition: 'background-color 0.2s, box-shadow 0.2s',
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                style={{ marginRight: '12px' }}
            >
                <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
            Sign in with Microsoft
        </button>
    );
}

export default MicrosoftSSO;
